<template>
  <div>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('addEditTypeOt.addEditTaches.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-12">
            <div class="card-article-any has-background-background has-text-centered"
                 v-if="typeOt.tachesTypeOt.length === 0">
              <h1 class="title is-size-3 pdt-50px">
                {{ $t('detailTypeOt.noTaches')}}
              </h1>
            </div>
            <div v-else>
              <draggable
                v-model="typeOt.tachesTypeOt"
                class="column is-12 pd-0"
                handle='.draggable-handle'
                @change="changeOrdre"
                :disabled="isDetail">
                <div v-for="(tache, index) in typeOt.tachesTypeOt"
                     :key="index">
                  <div class="card mgt-20px">
                    <div class="card-content">
                      <div class="columns" v-if="!isDetail">
                        <div class="column is-10">
                          <div class="columns">
                            <div class="column is-narrow mgv-auto">
                              <b-icon class="drag draggable-handle mgt-3px" icon="drag">
                              </b-icon>
                            </div>
                            <div class="column is-10" v-if="!isDetail">
                              <b-field :label="$t('addEditTypeOt.addEditTaches.libelle')">
                                <b-input
                                  v-model="tache.libelle"
                                  class="width-250 obligatoire">
                                </b-input>
                              </b-field>
                              <b-field :label="$t('addEditTypeOt.addEditTaches.description')">
                              <b-input
                                v-model="tache.description"
                                class="obligatoire mgt-10px">
                              </b-input>
                              </b-field>
                            </div>
                          </div>
                        </div>
                        <div class="column is-2 mgv-auto has-text-right">
                          <a @click="deleteTache(tache.ordre)">
                            <b-icon
                              icon="delete-forever"
                              type="is-danger">
                            </b-icon>
                          </a>
                        </div>
                      </div>
                      <div v-else>
                        <p class="is-size-5 has-text-weight-bold has-text-link">
                          {{ tache.libelle }}
                        </p>
                        <p class="has-text-default">
                          {{ tache.description }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div class="column is-12" v-if="!isDetail">
            <button
              class="button is-primary"
              @click="addTache()">
              {{ $t('addEditTypeOt.addEditTaches.action.add') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import genererTache from '@/services/logistique/typeOt/genererTache';

export default {
  props: {
    typeOt: {
      type: Object,
      required: true,
    },
    isDetail: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    draggable,
  },
  methods: {
    deleteTache(ordre) {
      const index = this.typeOt.tachesTypeOt.findIndex((tache) => {
        return tache.ordre === ordre;
      });
      if (index === -1) return;
      this.typeOt.tachesTypeOt.splice(index, 1);
    },
    addTache() {
      const ordres = this.typeOt.tachesTypeOt.map((tache) => {
        return tache.ordre;
      });
      const ordre = this.typeOt.tachesTypeOt && this.typeOt.tachesTypeOt.length > 0
        ? Math.max(...ordres) : 0;
      const tache = genererTache(ordre + 1);
      this.typeOt.tachesTypeOt.push(tache);
    },
    changeOrdre() {
      let ordre = 0;
      this.typeOt.tachesTypeOt.forEach(tache => {
        tache.ordre = ordre;
        ordre += 1;
      });
    },
  },
};
</script>
